import React, { FunctionComponent } from 'react';

import { MarketCode } from '../../../types/__generated-graphQL__';
import { MenuBar } from '../../components/Menu/MenuBar';
import { NotAuthorised } from './NotAuthorised';
import { SideBar } from '../../components/SideBar/SideBar';
import { useCharityData } from '../../context/charityContext';

type GivingCheckoutAccessWrapperProps = {
  children: React.ReactNode;
};

export const GivingCheckoutAccessWrapper: FunctionComponent<
  GivingCheckoutAccessWrapperProps
> = ({ children }) => {
  const { charity } = useCharityData();

  if (
    charity?.operatingCompanyCode === MarketCode.Us &&
    charity?.bbmsLiveForJG
  ) {
    return (
      <>
        <MenuBar showGivingCheckoutOption={false} />
        <div className="container jg-space-phms giving-checkout__container">
          <div className="row">
            <main className="col-lg-8">
              <NotAuthorised />
            </main>
            <aside className="col-lg-4">
              <SideBar />
            </aside>
          </div>
        </div>
      </>
    );
  }

  return <>{children}</>;
};
